import { NormalizedCacheObject } from 'apollo-boost';

import { XlsExportMode, XlsExportParams } from '../typings/xls';

import { BaseDataProvider } from './BaseDataProvider/BaseDataProvider';
import { DNAApolloClient } from './DNAApolloClient/DNAApolloClient';
import { RestApiManager } from './RestApiManager';

export class XlsDataProvider extends BaseDataProvider {
    private apiManager: RestApiManager;

    constructor(apiManager: RestApiManager, client: DNAApolloClient<NormalizedCacheObject>) {
        super(client);
        this.apiManager = apiManager;
    }

    public exportXls(
        exportMode: XlsExportMode,
        params: XlsExportParams,
        ulogin: string
    ): Promise<{ success: boolean; result: { exportFileUrl: string } }> {
        const requestParams: RequestInit = {
            method: 'POST',
            body: JSON.stringify({ ...params, exportMode })
        };

        return this.apiManager.exportXls(requestParams, ulogin);
    }
}
